import { Capacitor } from '@capacitor/core';
import { openExternalUrl } from './openExternalUrl';

const DEFAULT_PACKAGE = 'in.nmhelper.app';
const DEFAULT_HTTPS = `https://play.google.com/store/apps/details?id=${DEFAULT_PACKAGE}`;
const DEFAULT_MARKET = `market://details?id=${DEFAULT_PACKAGE}`;

/** Open Google Play — market:// on Android, https fallback. */
export async function openPlayStore({
  marketUrl = DEFAULT_MARKET,
  storeUrl = DEFAULT_HTTPS,
} = {}) {
  if (!Capacitor.isNativePlatform()) {
    openExternalUrl(storeUrl);
    return;
  }

  try {
    const { App } = await import('@capacitor/app');
    try {
      await App.openUrl({ url: marketUrl });
      return;
    } catch {
      await App.openUrl({ url: storeUrl });
      return;
    }
  } catch {
    openExternalUrl(storeUrl);
  }
}
